export default "__VITE_ASSET__CHUsfwyl__"